import { PropTypes } from 'base/react-libs';
import { setTaskCompletion } from 'apps/tasks/utils/tasks-actions';
import { trackJourneysAction } from 'apps/journeys/utils/helpers/mixpanel';
import TaskRow from './task-row';
import { useJourneyDetailProvider } from 'apps/journeys/context/journey-detail-context';

const TaskRowDetails = ({ step }) => {
  const { optionalStateManagementFunction } = useJourneyDetailProvider();

  const completeTaskStateUpdates = async (task, step) => {
    const markComplete = task.completed_at ? false : true;
    const type = markComplete ? 'complete_step' : 'uncomplete_step';
    trackJourneysAction('complete_toggle', type);
    const { completed_at } = await setTaskCompletion(task, markComplete);
    optionalStateManagementFunction('completionToggle', { task, step, completed_at });
  };

  const { tasks } = step;

  return (
    <div>
      {tasks &&
        tasks.map((task) => (
          <TaskRow key={task.id} step={step} task={task} handleCompletionClick={completeTaskStateUpdates} />
        ))}
    </div>
  );
};

TaskRowDetails.propTypes = {
  step: PropTypes.object,
};

export default TaskRowDetails;
